import React from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { projectsData } from '../../projectsData/projectsData';
import Footer from '../Shared/Footer/Footer';
import Header from '../Shared/Header/Header';
import './Details.css';

const Details = () => {
    const { id } = useParams();
    const singleProject = projectsData.find(data => data.id === parseInt(id));



    return (
        <>
            <Header />

            <section style={{ marginTop: '50px' }} className="details-container">
                <Container>
                    <div style={{ backgroundColor: '#24263B' }} className="card my-3">
                        <div >
                            <h2 data-aos="fade-left"
                                data-aos-offset="300"
                                data-aos-easing="ease-in-sine" className="fw-bold text-center fs-1">{singleProject?.name}</h2>
                            <img data-aos="fade-right"
                                data-aos-offset="300"
                                data-aos-easing="ease-in-sine" style={{ objectFit: 'cover', borderRadius: '30px' }} src={singleProject?.img} className="img-fluid p-3" alt="..." />
                        </div>
                        <div className="row g-0 py-2">

                            <div className="col-12 col-md-5 col-lg-5">
                                <div className="row">
                                    <div
                                        data-aos="fade-right"
                                        data-aos-offset="300"
                                        data-aos-easing="ease-in-sine"
                                        className="col-md-12 col-12 col-lg-12 ">

                                        <img style={{ objectFit: 'cover', borderRadius: '30px' }} src={singleProject?.img1} className="img-fluid p-3" alt="..." />
                                    </div>
                                    <div
                                        data-aos="fade-right"
                                        data-aos-offset="300"
                                        data-aos-easing="ease-in-sine"
                                        className="col-md-12 col-12 col-lg-12 ">

                                        <img style={{ objectFit: 'cover', borderRadius: '30px' }} src={singleProject?.img3} className="img-fluid p-3" alt="..." />
                                    </div>
                                </div>
                            </div>

                            <div
                                data-aos="fade-left"
                                data-aos-offset="300"
                                data-aos-easing="ease-in-sine"
                                className="col-md-7 p-3">
                                <div className="card-body">
                                    <h6>Featured - Application</h6>

                                    <p className="lh-base -2">{singleProject?.shortDescription}</p>
                                    <p className="w-100 d-flex flex-wrap mb-1">
                                        <span className="tech-html">{singleProject?.technology?.tech1}</span>
                                        <span className="tech-css">{singleProject?.technology?.tech2}</span>
                                        <span className="tech-bootstrap">{singleProject?.technology?.tech3}</span>
                                        {
                                            singleProject.technology.tech4 && <span className="tech-react">{singleProject?.technology?.tech4}</span>
                                        }
                                        {
                                            singleProject.technology.tech5 && <span className="tech-firebase">{singleProject?.technology?.tech5}</span>
                                        }
                                        {
                                            singleProject.technology.tech6 && <span className="tech-mongoDB">{singleProject?.technology?.tech6}</span>
                                        }
                                        {
                                            singleProject.technology.tech7 && <span className="tech-express">{singleProject?.technology?.tech7}</span>
                                        }
                                        {
                                            singleProject.technology.tech8 && <span className="tech-node">{singleProject?.technology?.tech8}</span>
                                        }
                                    </p>
                                    <a href={singleProject.liveSite} rel="noreferrer" target="_blank">
                                        <button className="primary-button my-2">View Project</button>
                                    </a>
                                    <a href={singleProject.clientSideCode} rel="noreferrer" target="_blank">
                                        <button className="primary-button my-2">Client-Side-Code</button>
                                    </a>
                                    {
                                        singleProject.serverSideCode && <a href={singleProject.serverSideCode} rel="noreferrer" target="_blank">
                                            <button className="primary-button my-2">Server-Side-Code</button>
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-left "
                            data-aos-offset="300"
                            data-aos-easing="ease-in-sine">
                            <img

                                style={{ objectFit: 'cover', borderRadius: '30px' }} src={singleProject?.img2} className="img-fluid p-3" alt="..." />
                            <p className=" p-3">{singleProject?.description}</p>
                        </div>
                    </div>

                </Container>
            </section>
            <Footer />
        </>
    );
};

export default Details;